module.exports = __webpack_public_path__ + "img/i_homework-status-not-checked.e3ffaa2b.svg";